import { WSCard, WSText } from "@wingspanhq/fe-component-library";
import { RequirementType } from "@wingspanhq/payments/dist/interfaces";
import { useUserId } from "../../../query/hooks/helpers";
import { useQueryRequirementsList } from "../../../query/requirements/queries/useQueryRequirementsList";
import { useQueryPayerRows } from "../../../query/search/payer/queries/useQueryPayerRows";
import { getPayerNamesList } from "../../Payers/utils/getPayerNames";

export const CardPayoutMethodRequirementRequester = () => {
  const userId = useUserId();

  const queryRequirements = useQueryRequirementsList({
    filter: {
      payeeId: userId,
      payerPayeeEngagementIds: {
        "!=": "null"
      },
      requirementType: RequirementType.PayoutMethod
    }
  });

  const payerIds = (queryRequirements.data || []).map(
    requirement => requirement.payerId
  );

  const queryPayers = useQueryPayerRows({
    filter: {
      payerId: {
        in: payerIds
      }
    }
  });

  const payerNames = getPayerNamesList(queryPayers.data || []);

  return (
    <WSCard header="Payout method">
      <WSText.ParagraphSm color="gray600">
        Complete your account setup by providing your payout method below as
        required by {payerNames.join(", ")} to receive payments from them.
      </WSText.ParagraphSm>
    </WSCard>
  );
};
